import { FunctionalComponent, h } from 'preact';
import { withGhId } from '../apiConfig';

/**
 * 底部导航（三频道）：线性 SVG 图标，选中态 = 红色 + 加粗描边（不填充，保留图标细节，G09）
 */
const ICONS: Record<string, FunctionalComponent<{ active?: boolean }>> = {
  home: ({ active }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={active ? 2.4 : 1.7}>
      <rect x="3" y="6" width="18" height="15" rx="3" />
      <path d="m8 2 4 4 4-4" stroke-linecap="round" stroke-linejoin="round" />
      <path d="m10 10 6 3.5-6 3.5z" stroke-linejoin="round" />
    </svg>
  ),
  featured: ({ active }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={active ? 2.4 : 1.7}>
      <path d="M12 2.8l2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3-4.6-4.4 6.3-.9z" stroke-linejoin="round" />
    </svg>
  ),
  calendar: ({ active }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={active ? 2.4 : 1.7}>
      <rect x="3" y="5" width="18" height="16" rx="3" />
      <path d="M3 10h18M8 3v4M16 3v4" stroke-linecap="round" />
      {active ? <circle cx="12" cy="15.5" r="2.6" /> : <path d="M7.5 14.5h3M13.5 14.5h3M7.5 17.5h3" stroke-linecap="round" stroke-width="1.6" />}
    </svg>
  ),
};

interface Props {
  active: 'home' | 'featured' | 'calendar';
}

const TabBar: FunctionalComponent<Props> = ({ active }) => (
  <nav class="vp-tabbar">
    {([
      ['home', '/live', '直播预告'],
      ['featured', '/live/featured', '直播精选'],
      ['calendar', '/live/calendar', '直播日历'],
    ] as const).map(([key, href, label]) => {
      const Icon = ICONS[key];
      return (
        <a class={`vp-tab${active === key ? ' active' : ''}`} href={withGhId(href)}>
          <span class="vp-tab-icon"><Icon active={active === key} /></span>
          {label}
        </a>
      );
    })}
  </nav>
);

export default TabBar;
